<template>
  <div>
    <logout-button v-if="$auth.isAuthenticated" />
    <login-button v-else />
  </div>
</template>

<script>
  import LoginButton from '@/components/auth/LoginButton'
  import LogoutButton from '@/components/auth/LogoutButton'

  export default {
    name: 'AuthenticationButton',
    components: { LogoutButton, LoginButton },
  }
</script>
